import React, { useState } from "react";
import { useEMRContext } from "./EMRContextGync";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import { useFormContext } from "react-hook-form";
import { Box, Modal, Tooltip } from "@mui/material";
import InputField from "../../../common/components/FormFields/InputField";
import CommonButton from "../../../common/components/Buttons/CommonButton";

export default function ANCPatientInfo(props) {
  const { vital, setVital, isDirty, setIsDirty } = useEMRContext();

  const [row, setRow] = useState();
  const [editData, setEditData] = useState(false);
  const [index, setIndex] = useState();
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    watch,
    register,
    setValue,
    setError,
    clearErrors,
  } = useFormContext({
    // resolver: yupResolver(validationSchema),
    // defaultValues: {
    //   patientMobileNo: "",
    // },
  });
  const onSubmit = () => { };
  const mobileNoRef = /^[0-9]{0,14}$/;
  // let getPatientMobileNo = watch("patientMobileNo");

  // function validInputValue(type) {
  //   console.log("typetype123", type);
  //   if (type === "patientMobileNo") {
  //     if (
  //       Number(getPatientMobileNo?.length) < Number(10) ||
  //       Number(getPatientMobileNo?.length) > Number(14)
  //     ) {
  //       console.log("getPatientMobileNo123", getPatientMobileNo?.length);

  //       setError("patientMobileNo", {
  //         type: "custom",
  //         message: "Required",
  //       });
  //     } else {
  //       clearErrors("patientMobileNo");
  //     }
  //   } else if (type === "name") {
  //     if (value !== "") {
  //       console.log("valueLength123", value);
  //       setError("name", {
  //         type: "custom",
  //         message: "Required",
  //       });
  //     }
  //   }
  // }

  return (
    <div>
      <Modal
        open={props.openPartnerModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "65%",
            height: "75%",
            // maxHeight: "",
            overflowY: "visible",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflow: "auto",
          }}
        >
          <div className="text-base font-semibold  mb-4 flex justify-between bg-[#CFFAFE] ">
            <div className="text-sm font-semibold p-2">
              <h1>Partner & Patient Info</h1>
            </div>
            <div className="-mt-2">
              <CancelPresentationIconButton
                onClick={() => {
                  props.setOpenPartnerModal(false);
                  //   props.setEditOpen(false);
                }}
              />
            </div>
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid grid-cols-1 mb-2 border p-2 pb-2 border-[#D9D9D9] rounded-b-md bg-white px-2">
              <div className=" w-full flex  gap-2 py-1">
                <div className="w-[12%]">
                  <label>Partner Name </label>
                </div>

                <fieldset
                  className="w-[65%]"
                  onChange={(e) => {
                    // validInputValue("name", e.target.value);
                  }}
                >
                  <InputField
                    control={control}
                    name="name"
                    label="Name"
                    error={errors.name}
                  // inputRef={{
                  //   ...register("name", {
                  //     onChange: (e) => {
                  //       validInputValue("name");
                  //     },
                  //   }),
                  // }}
                  />
                </fieldset>
                <div className="w-[23%]">
                  <InputField
                    control={control}
                    name="age"
                    label="Partner Age"
                    type="Number"
                    inputRef={{
                      ...register("age", {
                        onChange: (e) => {
                          console.log("temperature555", e.target.value);
                          if (Number(e.target.value) < 0) {
                            console.log("isDirty777", isDirty);
                            setIsDirty(true);
                          } else {
                            setIsDirty(false);
                          }
                        },
                      }),
                    }}
                    error={
                      watch("age") < 0 ? { message: "Wrong Pulse Rate" } : null
                    }
                  />
                </div>
              </div>
              <div className="flex w-full gap-2 py-1">
                <div className="w-[12%]">
                  <label>Age During Marriage </label>
                </div>

                <div className="w-[45%]">
                  <InputField
                    control={control}
                    name="patientAgeDuringMarriage"
                    label="Patient Age During Marriage"
                    type="Number"
                  />
                </div>
                <div className="w-[45%]">
                  <InputField
                    control={control}
                    name="partnerAgeDuringMarriage"
                    label="Partner Age During Marriage"
                    type="Number"
                  />
                </div>
              </div>
              <div className="flex w-full gap-2 py-1">
                <div className="w-[12%]">
                  <label>Education </label>
                </div>

                <div className="w-[45%]">
                  <InputField
                    control={control}
                    name="patientEducation"
                    label="Patient Education "
                  />
                </div>
                <div className="w-[45%]">
                  <InputField
                    control={control}
                    name="partnerEducation"
                    label="Partner Education"
                  />
                </div>
              </div>
              <div className="flex w-full gap-2 py-1">
                <div className="w-[12%]">
                  <label>Occupation </label>
                </div>

                <div className="w-[45%]">
                  <InputField
                    control={control}
                    name="patientOccupation"
                    label="Patient Occupation"
                  />
                </div>
                <div className="w-[45%]">
                  <InputField
                    control={control}
                    name="partnerOccupation"
                    label="Partner Occupation"
                  />
                </div>
              </div>
              <div className="flex w-full gap-2 py-1">
                <div className="w-[12%]">
                  <label>Aadhar No. </label>
                </div>

                <div className="w-[45%]">
                  <InputField
                    control={control}
                    name="patientAadharNo"
                    label="Patient Aadhar No."
                    type="Number"
                    inputRef={{
                      ...register("patientAadharNo", {
                        pattern: {
                          value: /^\d{12}$/,
                          message: "Aadhar No. must be 12 digits",
                        },
                      }),
                    }}
                    error={errors.patientAadharNo}
                  />
                </div>
                <div className="w-[45%]">
                  <InputField
                    control={control}
                    name="partnerAadharNo"
                    label="Partner Aadhar No."
                    type="Number"
                    inputRef={{
                      ...register("partnerAadharNo", {
                        pattern: {
                          value: /^\d{12}$/,
                          message: "Aadhar No. must be 12 digits",
                        },
                      }),
                    }}
                    error={errors.partnerAadharNo}
                  />
                </div>
              </div>
              <div className="flex w-full gap-2 py-1">
                <div className="w-[12%]">
                  <label>Mobile No.</label>
                </div>

                <div className="w-[45%]">
                  <InputField
                    control={control}
                    name="patientMobileNo"
                    label="Patient Mobile No."
                    type="Number"
                    inputRef={{
                      ...register("patientMobileNo", {
                        pattern: {
                          value: /^\d{10}$/,
                          message: "Mobile No. must be 10 digits",
                        },
                      }),
                    }}
                    error={errors.patientMobileNo}
                  />
                </div>
                <div className="w-[45%]">
                  <InputField
                    control={control}
                    name="partnerMobileNo"
                    label="Partner Mobile No."
                    type="Number"
                    inputRef={{
                      ...register("partnerMobileNo", {
                        pattern: {
                          value: /^\d{10}$/,
                          message: "Mobile No. must be 10 digits",
                        },
                      }),
                    }}
                    error={errors.partnerMobileNo}
                  />
                </div>
              </div>
            </div>


            <div className="flex justify-end">
              <CommonButton
                label="Add"
                type="button"
                className="addButton border border-customBlue text-customBlue"
                onClick={() => {
                  props.setOpenPartnerModal(false);
                }}
              />
            </div>



          </form>
        </Box>
      </Modal>
    </div>
  );
}
